import { getEmbedConfig } from './config';

export interface FeatureFlags {
  enableServerFallback: boolean;
  enableFeedbackForm: boolean;
  enableAnalytics: boolean;
  enablePremiumFinishes: boolean;
  enableShareButton: boolean;
  maxUploadSizeMB: number;
  renderStrategy: 'gemini';
}

const DEFAULT_FLAGS: FeatureFlags = {
  enableServerFallback: true,
  enableFeedbackForm: true,
  enableAnalytics: true,
  enablePremiumFinishes: true,
  enableShareButton: false,
  maxUploadSizeMB: 20,
  renderStrategy: 'gemini',
};

function getBoolFlag(
  ff: Record<string, boolean | number | string>,
  key: keyof FeatureFlags,
  defaultValue: boolean
): boolean {
  const val = ff[key];
  return typeof val === 'boolean' ? val : defaultValue;
}

export function getFeatureFlags(): FeatureFlags {
  const config = getEmbedConfig();
  const ff = config.featureFlags;

  return {
    enableServerFallback: getBoolFlag(ff, 'enableServerFallback', DEFAULT_FLAGS.enableServerFallback),
    enableFeedbackForm: getBoolFlag(ff, 'enableFeedbackForm', DEFAULT_FLAGS.enableFeedbackForm),
    enableAnalytics: getBoolFlag(ff, 'enableAnalytics', DEFAULT_FLAGS.enableAnalytics),
    enablePremiumFinishes: getBoolFlag(ff, 'enablePremiumFinishes', DEFAULT_FLAGS.enablePremiumFinishes),
    enableShareButton: getBoolFlag(ff, 'enableShareButton', DEFAULT_FLAGS.enableShareButton),
    maxUploadSizeMB:
      typeof ff.maxUploadSizeMB === 'number' ? ff.maxUploadSizeMB : DEFAULT_FLAGS.maxUploadSizeMB,
    renderStrategy:
      typeof ff.renderStrategy === 'string'
        ? (ff.renderStrategy as FeatureFlags['renderStrategy'])
        : DEFAULT_FLAGS.renderStrategy,
  };
}

export function isFeatureEnabled(flag: keyof FeatureFlags): boolean {
  const flags = getFeatureFlags();
  const value = flags[flag];
  return typeof value === 'boolean' ? value : false;
}
